require('./optionGroupMultiSelect.i18n.json');
require('./optionGroupMultiSelect.tpl.html');
require('./optionGroupMultiSelectController.js');

const OptionGroupMultiSelectComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupMultiSelect/optionGroupMultiSelect.tpl.html',
    controller: 'optionGroupMultiSelectController',
    bindings: {
        selectedField: '<',
        name: '<',
        label: '<',
        values: '<',
        value: '<',
        valueDelimiter: '<',
        isDisabled: '<',
        defaultPromptValue: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupMultiSelect', OptionGroupMultiSelectComponent);
